// extracted by mini-css-extract-plugin
module.exports = {"root":"Logo_root__kS2l_","wrapper":"Logo_wrapper__G0r8S","logo":"Logo_logo__T21r4"};